import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, onUnmounted, ref, useTemplateRef } from 'vue';
import { useGalleryListeners } from '../../composables/galleryListeners';
import type { GalleryElement } from '@/interfaces/components/galleryElement';
import GalleryModalWithGrid from '@lmt-rpb-new/molecules/GalleryModalNew/GalleryModalWithGrid.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegionGallery',
  setup(__props) {

const galleryItems = ref<Array<GalleryElement>>([]);
const galleryIndex = ref(0);
const gridModalRef = useTemplateRef('gridModalRef');
const regionName = ref<string>('');

function extractRegionName(): string {
	const container = document.querySelector('.rpb_container.media-mosaic > h2') as HTMLElement;
	if (!container?.innerText) return '';

	const parts = container.innerText.trim().split(' ');
	return parts.length > 1 ? parts[1] : '';
}

function initLightboxImages() {
	const elements = document.querySelectorAll<HTMLLIElement>('[data-lightbox-content]');

	return Array.from(elements).map((element) => ({
		content: element.dataset.lightboxContent,
		preview: element.dataset.lightboxPreview ?? element.dataset.lightboxContent,
		copyright: element.dataset.lightboxCopyright ?? '',
		type: element.dataset.lightboxType ?? 'image',
	}));
}

function initAdditionalImages() {
	const mosaicData: HTMLElement | null = document.querySelector('.media-mosaic-data');
	if (!mosaicData?.dataset.mosaic) {
		mosaicData?.remove();
		return [];
	}
	const elements: {
		alt_text: string;
		copyright?: string;
		medium?: string;
		original: string;
		small: string;
		title: string;
	}[] = JSON.parse(mosaicData.dataset.mosaic);
	mosaicData?.remove();

	return Array.from(elements).map((element) => ({
		content: element.original,
		preview: element.small ?? element.original,
		copyright: element.copyright ?? '',
		type: 'image',
	}));
}

function initLightboxVideo() {
	const elements = document.querySelectorAll<HTMLLIElement>('[data-lightbox-video-content]');

	return Array.from(elements).map((element) => ({
		content: element.dataset.lightboxVideoContent,
		preview: element.dataset.lightboxVideoPreview ?? element.dataset.lightboxVideoContent,
		copyright: element.dataset.lightboxVideoCopyright ?? '',
		type: element.dataset.lightboxVideoType ?? 'image',
	}));
}

function initGalleryImages() {
	galleryItems.value = [...initLightboxImages(), ...initAdditionalImages(), ...initLightboxVideo()] as GalleryElement[];
}

const handleButtonClick = () => {
	galleryIndex.value = 0;
	if (gridModalRef.value) {
		gridModalRef.value.openGalleryGridModal();
	}
};

const openGallery = (index: number) => {
	galleryIndex.value = index;
	if (gridModalRef.value) {
		gridModalRef.value.openGalleryGridModal();
	}
};

// Initialize click listeners for mosaic images
useGalleryListeners('.media-mosaic__image', openGallery);

onMounted(() => {
	initGalleryImages();
	regionName.value = extractRegionName();
	document.querySelector('.media-mosaic__button')?.addEventListener('click', handleButtonClick);
});

onUnmounted(() => {
	document.querySelector('.media-mosaic__button')?.removeEventListener('click', handleButtonClick);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GalleryModalWithGrid, {
    ref_key: "gridModalRef",
    ref: gridModalRef,
    "focused-index": galleryIndex.value,
    "header-title": regionName.value,
    "gallery-items": galleryItems.value
  }, null, 8 /* PROPS */, ["focused-index", "header-title", "gallery-items"]))
}
}

})